<div class="file-explorer" *ngIf="loaded">
  <div class="top-bar">
    <!-- Botón Nueva Carpeta -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      (click)="openModal()" [disabled]="currentDirectory.permisos?.CARPETA_NUEVA === false">
      <span class="btn-label"><i class="fe-folder-plus"></i></span><span i18n>Nueva carpeta</span>
    </button>

    <!-- Botón Renombrar Carpeta -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      (click)="renameNode(currentDirectory)"
      [disabled]="currentDirectory.id_padre === null || currentDirectory.permisos?.CARPETA_RENOMBRAR === false">
      <span class="btn-label"><i class="fe-folder-minus"></i></span><span i18n>Renombrar carpeta</span>
    </button>

    <!-- Botón Borrar Carpeta -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      (click)="deleteNode(currentDirectory)"
      [disabled]="currentDirectory.id_padre === null || currentDirectory.permisos?.CARPETA_BORRAR === false">
      <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar carpeta</span>
    </button>

    <!-- Botón Cambiar Tipo -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      (click)="changePermissions(currentDirectory)"
      [disabled]="currentDirectory.id_padre === null || currentDirectory.permisos?.CARPETA_CAMBIAR_TIPO === false">
      <span class="btn-label"><i class="fe-user"></i></span><span i18n>Cambiar tipo</span>
    </button>

    <!-- Botón Subir Archivo -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      *ngIf="tipoExplorador === 'expediente'" (click)="openUploadFileModal()"
      [disabled]="currentDirectory.permisos?.CARPETA_SUBIR_ARCHIVO === false">
      <span class="btn-label"><i class="fe-upload"></i></span><span i18n>Subir archivo</span>
    </button>

    <!-- Botón ZIP (deshabilitado si el permiso en root es false) -->
    <button class="btn btn-primary waves-effect waves-light small-button" style="margin-right: 20px;"
      *ngIf="tipoExplorador === 'expediente'" (click)="downloadAndSaveZip(id_expediente)"
      [disabled]="rootDirectory.permisos?.CASO_DESCARGAR_ZIP === false">
      <span class="btn-label"><i class="fe-download"></i></span><span>ZIP</span>
    </button>

    <div *ngIf="tipoExplorador === 'expediente'" style="display: flex; flex-direction: column;">
      <span style="font-size: 12px; vertical-align: middle;" i18n>Tamaño:</span>
      <span style="font-size: 12px; vertical-align: middle;">{{ tamanioKB_total }}</span>
    </div>

  </div>

  <div class="container">
    <div class="sidebar">
      <div class="folder-tree">
        <ul>
          <ng-container *ngFor="let node of rootDirectory.hijos">
            <ng-container *ngIf="node.permisos?.CARPETA_ACCESO_CONTENIDO !== false">
              <li>
                <div class="folder-item" [class.selected]="node === currentDirectory" [id]="node.id">
                  <span (click)="toggleFolder(node)">
                    <i [ngClass]="{'fe-chevron-down bold': node.expanded, 'fe-chevron-right': !node.expanded}"></i>
                  </span>
                  <span (click)="selectFolder(node, $event)">
                    {{ node.expanded ? '📂' : '📁' }}
                    {{ node.nombre }} <span *ngIf="tipoExplorador === 'expediente'">
                      <!--  &nbsp;({{ formatSize((node.tamanioKB_total || 0) * 1024) }}) -->
                    </span>
                  </span>
                </div>
                <ul *ngIf="node.expanded">
                  <ng-container *ngTemplateOutlet="recursiveTree; context: { $implicit: node.hijos }"></ng-container>
                </ul>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>

    <div class="main-view">
      <div class="breadcrumb"
        style="display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap;">
        <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          <i class="breadcrumb-icon" *ngIf="currentDirectory.id != 'root'">📁</i>
          <span class="breadcrumb-separator" *ngIf="currentDirectory.id != 'root'">
            <i class="fe-chevron-right"></i>
          </span>
          <ng-container *ngIf="getBreadcrumb().hidden">
            <span class="breadcrumb-item" style="cursor: default;">...</span>
            <span class="breadcrumb-separator">
              <i class="fe-chevron-right"></i>
            </span>
          </ng-container>
          <ng-container *ngFor="let node of getBreadcrumb().visible; let i = index">
            <span (click)="navigateToBreadcrumb(node)" class="breadcrumb-item">
              {{ node.nombre }}
            </span>
            <span *ngIf="i < getBreadcrumb().visible.length - 1" class="breadcrumb-separator">
              <i class="fe-chevron-right"></i>
            </span>
          </ng-container>
        </div>
        <button class="btn btn-primary waves-effect waves-light small-button"
          style="margin-left: 10px; padding: 5px 10px; white-space: nowrap; flex-shrink: 0;"
          *ngIf="tipoExplorador === 'expediente'" (click)="openSearchModal()">
          <span class="btn-label"><i class="fe-search"></i></span> <span i18n>Buscar archivos</span>
        </button>
      </div>



      <div class="file-details">
        <table>
          <thead>
            <tr>
              <th (click)="toggleSortOrder()" style="cursor: pointer;">
                <span i18n>Nombre</span> &nbsp;
                <i *ngIf="sortAscending" class="fas fa-sort-alpha-down"></i>
                <i *ngIf="!sortAscending" class="fas fa-sort-alpha-up"></i>
              </th>
              <th *ngIf="tipoExplorador ==='plantilla'" style="text-align: right; width: 20px;" i18n>Tipo</th>
              <th *ngIf="tipoExplorador ==='expediente'" style="text-align: left;" i18n>#Num</th>
              <th *ngIf="tipoExplorador ==='expediente'" style="text-align: left;" i18n>Subido por</th>
              <th *ngIf="tipoExplorador ==='expediente'" style="white-space: nowrap; text-align: right; width: 130px;"
                i18n>
                Fecha de subida
              </th>
              <th *ngIf="tipoExplorador ==='expediente'" style="white-space: nowrap; text-align: right; width: 130px;"
                i18n>
                Tipo
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngIf="currentDirectory !== rootDirectory && currentDirectory.id_padre !== null && tipoExplorador ==='plantilla'"
              (click)="goBack()">
              <td>📁 ..</td>
              <td></td>
            </tr>
            <tr
              *ngIf="currentDirectory !== rootDirectory && currentDirectory.id_padre !== null && tipoExplorador ==='expediente'"
              (click)="goBack()">
              <td>📁 ..</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- Mostrar carpetas -->
            <tr *ngFor="let node of currentDirectory.hijos">
              <td (click)="navigateTo(node)">
                <span *ngIf="node.hijos">📁</span>
                {{ node.nombre }}
              </td>
              <td *ngIf="tipoExplorador ==='expediente'">{{ (node.num_archivos ?? 0) + (node.num_carpetas ?? 0) }}</td>
              <td *ngIf="tipoExplorador ==='expediente'">{{ node.modifiedDate | date: 'short' }}</td>
              <td *ngIf="tipoExplorador ==='expediente'">{{ formatSize(node.size) }}</td>
              <td *ngIf="tipoExplorador ==='plantilla'" [ngStyle]="{ 'font-size': '12px' }">{{
                transformarTipo(node.tipo) | titlecase }}
              </td>
              <td *ngIf="tipoExplorador ==='expediente'" [ngStyle]="{ 'font-size': '12px' }"> {{
                transformarTipo(node.tipo) | titlecase }}
                <!-- Aprovecho la columna de opciones de fichero para meter el Tipo -->
              </td>
            </tr>

            <!-- Mostrar archivos -->
            <!-- En la tabla de archivos -->
            <tr *ngFor="let file of currentDirectory['archivos'] || []">
              <td
                style="max-width: 280px; word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                (mouseenter)="toggleTooltipFile(file['id'], true, $event)"
                (mouseleave)="toggleTooltipFile(file['id'], false)">
                <i class="material-icons" [style.color]="getFileIconColor(file['tipo_mime'])"
                  style="margin-right: 5px;">
                  {{ getFileIcon(file['tipo_mime']) }}
                </i>
                <span [innerHTML]="preserveSpaces(file.nombre)"></span>
                <div [id]="'tooltipFile-' + file['id']" class="tooltip-info">
                  {{ file.nombre }}
                </div>
              </td>
              <td *ngIf="tipoExplorador ==='expediente'"></td>
              <td *ngIf="tipoExplorador === 'expediente'" class="truncate-text" style="text-align: left;"
                (mouseenter)="toggleTooltip('subidoPor-' + file['id'], true, $event)"
                (mouseleave)="toggleTooltip('subidoPor-' + file['id'], false)">
                {{ getUploaderDisplay(file) }}
                <div [id]="'tooltip-subidoPor-' + file['id']" class="tooltip-info">
                  {{ file['usuario_nombre'] }} {{ file['usuario_apellidos'] }}<br>({{file['usuario_email']}})
                </div>
              </td>


              <td *ngIf="tipoExplorador === 'expediente'">
                {{ file['fecha_subida'] ? formatDateStringWithTime(file['fecha_subida']) : '' }}
              </td>
              <td>
                <!-- Botón de descarga -->
                <span class="icon-container">
                  <i class="material-icons-outlined"
                    (click)="currentDirectory.permisos?.ARCHIVO_LECTURA !== false && downloadAndSaveFile(file['id'], file['nombre'])"
                    style="cursor: pointer;"
                    [ngClass]="{'disabled-icon': currentDirectory.permisos?.ARCHIVO_LECTURA === false}">cloud_download</i>
                </span>

                <!-- Botón de previsualización -->
                <span class="icon-container">
                  <i class="material-icons-outlined"
                    [ngClass]="{'disabled-icon': !isPreviewable(file['tipo_mime']) || currentDirectory.permisos?.ARCHIVO_LECTURA === false}"
                    [style.cursor]="(!isPreviewable(file['tipo_mime']) || currentDirectory.permisos?.ARCHIVO_LECTURA === false) ? 'not-allowed' : 'pointer'"
                    (click)="isPreviewable(file['tipo_mime']) && currentDirectory.permisos?.ARCHIVO_LECTURA !== false && previewFile(file['id'], file['nombre'], file['tipo_mime'])">
                    {{ isPreviewable(file['tipo_mime']) && currentDirectory.permisos?.ARCHIVO_LECTURA !== false ?
                    'visibility' : 'visibility_off' }}
                  </i>
                </span>

                <!-- Menú de opciones: renombrar / info / borrar -->
                <div class="dropdown d-inline-block">
                  <button class="btn btn-sm dropdown-toggle p-1 bg-transparent border-0" type="button"
                    id="fileMenu-{{file.id}}" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fe-more-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'fileMenu-' + file.id">

                    <!-- Renombrar -->
                    <li>
                      <button class="dropdown-item d-flex align-items-center"
                        (click)="currentDirectory.permisos?.ARCHIVO_RENOMBRAR !== false && openRenameFileModal(file)"
                        [class.disabled]="currentDirectory.permisos?.ARCHIVO_RENOMBRAR === false">
                        <i class="fe-edit-2 me-2"></i>
                        <span i18n>Renombrar</span>
                      </button>
                    </li>

                    <!-- Mover a (placeholder) -->
                    <li>
                      <button class="dropdown-item d-flex align-items-center"
                      (click)="currentDirectory.permisos?.ARCHIVO_MOVER!== false &&openMoveFileModal(file)"
                      [class.disabled]="currentDirectory.permisos?.ARCHIVO_MOVER === false">
                        <i class="fe-arrow-right me-2"></i>
                        <span i18n>Mover a</span>
                      </button>
                    </li>

                    <li>
                      <hr class="dropdown-divider" />
                    </li>

                    <!-- Tamaño -->
                    <li>
                      <h6 class="dropdown-header">
                        Tamaño: {{ formatSize(file.tamanoKB * 1024) }}
                      </h6>
                    </li>

                    <!-- Borrar -->
                    <li>
                      <button class="dropdown-item d-flex align-items-center text-danger"
                        (click)="currentDirectory.permisos?.ARCHIVO_BORRAR !== false && openDeleteFileModal(file)"
                        [class.disabled]="currentDirectory.permisos?.ARCHIVO_BORRAR === false">
                        <i class="fe-trash me-2"></i>
                        <span i18n>Borrar</span>
                      </button>
                    </li>
                  </ul>
                </div>

              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div id="status" *ngIf="!loaded && !error">
  <div class="spinner"></div>
</div>

<div *ngIf="!loaded && error">
  <p>{{ error }}</p>
</div>

<!-- Modal para crear nuevo directorio -->
<div class="new-folder-modal" *ngIf="showModal">
  <div class="new-folder-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Nueva carpeta</h5>
    </div>
    <div class="new-folder-modal-body">
      <form [formGroup]="newFolderForm">
        <div class="form-group">
          <label for="folderName" i18n>Nombre de la carpeta</label>
          <input type="text" id="folderName" formControlName="nombre" class="form-control" #folderNameInput
            [ngClass]="{'is-invalid': newFolderForm.get('nombre')?.invalid && newFolderForm.get('nombre')?.touched}">
          <div *ngIf="newFolderForm.get('nombre')?.invalid && newFolderForm.get('nombre')?.touched"
            class="invalid-feedback" i18n>
            El nombre de la carpeta es obligatorio.
          </div>
        </div>
        <div class="form-group" style="margin-top: 20px;">
          <label for="folderType" i18n>Tipo</label>
          <select class="form-select" id="folderType" formControlName="tipo"
            [ngClass]="{'is-invalid': newFolderForm.get('tipo')?.invalid && newFolderForm.get('tipo')?.touched}">
            <option value="" disabled>Seleccione un tipo</option>
            <option value="LETRADO">LETRADO</option>
            <option value="ADMINISTRADOR">ADMINISTRADOR</option>
            <option value="SECRETARIA_GENERAL">SECRETARIA GENERAL</option>
            <option value="DEMANDANTE">DEMANDANTE</option>
            <option value="DEMANDADO">DEMANDADO</option>
            <option value="TRIBUNAL">TRIBUNAL</option>
            <option value="SECRETARIO_ADMINISTRATIVO">SECRETARIO ADMINISTRATIVO</option>
            <option value="EQUIPO_TRIBUNAL">EQUIPO TRIBUNAL</option>
          </select>
          <div *ngIf="newFolderForm.get('tipo')?.invalid && newFolderForm.get('tipo')?.touched"
            class="invalid-feedback">
            El tipo de directorio es obligatorio.
          </div>
        </div>
      </form>
    </div>
    <div class="new-folder-modal-footer">
      <button type="button" class="btn btn-primary waves-effect waves-light" style="margin-right: 20px;"
        (click)="createNewFolder()" [disabled]="newFolderForm.invalid"><span class="btn-label"><i
            class="fe-folder-plus"></i></span><span i18n>Crear</span></button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeModal()"><span
          class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span></button>
    </div>
  </div>
</div>

<!-- Modal para confirmar borrado de carpeta-->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar la carpeta</span> "{{ nodeToDelete?.nombre }}"?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal para renombrar carpeta -->
<div class="rename-folder-modal" *ngIf="showRenameModal">
  <div class="rename-folder-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Renombrar carpeta</h5>
    </div>
    <div class="rename-folder-modal-body">
      <form [formGroup]="renameFolderForm">
        <div class="form-group">
          <label for="renameFolderName" i18n>Nuevo nombre</label>
          <input type="text" id="renameFolderName" formControlName="nombre" class="form-control"
            [ngClass]="{'is-invalid': renameFolderForm.get('nombre')?.invalid && renameFolderForm.get('nombre')?.touched}">
          <div *ngIf="renameFolderForm.get('nombre')?.invalid && renameFolderForm.get('nombre')?.touched"
            class="invalid-feedback">
            El nombre del directorio es obligatorio.
          </div>
        </div>
      </form>
    </div>
    <div class="rename-folder-modal-footer">
      <button type="button" class="btn btn-primary waves-effect waves-light" (click)="confirmRename()"
        [disabled]="renameFolderForm.invalid" style="margin-right: 20px;"><span class="btn-label"><i
            class="fe-folder-plus"></i></span><span i18n>Renombrar</span></button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeRenameModal()"><span
          class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span></button>
    </div>
  </div>
</div>

<!-- Modal para cambiar permisos -->
<div class="custom-modal" *ngIf="showChangePermissionsModal">
  <div class="custom-modal-content-small">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Cambiar tipo</h5>
    </div>
    <div class="custom-modal-body">
      <form [formGroup]="changePermissionsForm">
        <div class="form-group">
          <label for="changePermissions">Tipo</label>
          <select class="form-select" id="changePermissions" formControlName="tipo"
            [ngClass]="{'is-invalid': changePermissionsForm.get('tipo')?.invalid && changePermissionsForm.get('tipo')?.touched}">
            <option value="" disabled>Seleccione un tipo</option>
            <option value="LETRADO">LETRADO</option>
            <option value="ADMINISTRADOR">ADMINISTRADOR</option>
            <option value="SECRETARIA_GENERAL">SECRETARIA GENERAL</option>
            <option value="DEMANDANTE">DEMANDANTE</option>
            <option value="DEMANDADO">DEMANDADO</option>
            <option value="TRIBUNAL">TRIBUNAL</option>
            <option value="SECRETARIO_ADMINISTRATIVO">SECRETARIO ADMINISTRATIVO</option>
            <option value="EQUIPO_TRIBUNAL">EQUIPO TRIBUNAL</option>
          </select>
          <div *ngIf="changePermissionsForm.get('tipo')?.invalid && changePermissionsForm.get('tipo')?.touched"
            class="invalid-feedback">
            El tipo es obligatorio.
          </div>
        </div>
      </form>
    </div>
    <div class="custom-modal-footer">
      <button type="button" class="btn btn-primary waves-effect waves-light" (click)="confirmChangePermissions()"
        [disabled]="changePermissionsForm.invalid" style="margin-right: 20px;"><span class="btn-label"><i
            class="fe-edit-2"></i></span><span>Cambiar</span></button>
      <button type="button" class="btn btn-secondary waves-effect waves-light"
        (click)="closeChangePermissionsModal()"><span class="btn-label"><i
            class="fe-x"></i></span><span>Cancelar</span></button>
    </div>
  </div>
</div>

<!-- Modal para subir ficheros -->
<div class="upload-file-modal" *ngIf="showUploadFileModal">
  <div class="upload-file-modal-content">
    <div class="upload-file-modal-header">
      <h5 class="upload-file-modal-title" i18n>Subir archivos</h5>
      <button type="button" class="btn-close" (click)="closeUploadFileModal()"></button>
    </div>
    <div class="upload-file-modal-body">
      <app-file-upload (filesDropped)="onFilesDropped($event)" [accept]="allowedFileTypes"></app-file-upload>

      <!-- Mensaje de advertencia y barra de progreso durante la subida -->
      <div *ngIf="uploading">
        <p i18n>No cierre esta ventana mientras se suben los archivos...</p>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width]="progress + '%'" [attr.aria-valuenow]="progress"
            aria-valuemin="0" aria-valuemax="100">{{ progress }}%
          </div>
        </div>
      </div>

      <!-- Mensaje de confirmación cuando la subida esté completa -->
      <div *ngIf="uploadComplete && !uploading" style="margin-top: 15px;">
        <p i18n>Subida completa.</p>
      </div>

      <!-- Mostrar mensaje de error si existe -->
      <div *ngIf="uploadErrorMessage" class="alert alert-danger error-container" style="margin-top: 15px;">
        <div class="error-messages" [innerHTML]="uploadErrorMessage">
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Modal para previsualizar archivo -->
<div class="preview-file-modal" *ngIf="showPreviewFileModal">
  <div class="preview-file-modal-content">
    <div class="preview-file-modal-header">
      <h5 class="preview-file-modal-title">{{ previewFileName }}</h5>
      <button type="button" class="btn-close" (click)="closePreviewFileModal()"></button>
    </div>
    <div class="preview-file-modal-body">
      <img *ngIf="isImage(previewFileType)" [src]="previewFileUrl" alt="{{ previewFileName }}" />
      <iframe *ngIf="isPDF(previewFileType)" [src]="previewFileUrl || ''" style="width: 100%; height: 100%"></iframe>
      <p *ngIf="!isImage(previewFileType) && !isPDF(previewFileType)" i18n>
        No se puede previsualizar este tipo de archivo.
      </p>
    </div>
  </div>
</div>


<!-- Modal para confirmar borrado de archivos -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteFileModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar el archivo</span> "{{ fileToDelete?.nombre }}"?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" (click)="confirmDeleteFile()"
        style="margin-right: 20px;">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteFileModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>


<ng-template #recursiveTree let-nodes>
  <ul>
    <ng-container *ngFor="let node of nodes">
      <ng-container *ngIf="node.permisos?.CARPETA_ACCESO_CONTENIDO !== false">
        <li>
          <div class="folder-item" [class.selected]="node === currentDirectory" [id]="node.id">
            <span (click)="toggleFolder(node)">
              <i [ngClass]="{'fe-chevron-down bold': node.expanded, 'fe-chevron-right': !node.expanded}"></i>
            </span>
            <span (click)="selectFolder(node, $event)">
              {{ node.expanded ? '📂' : '📁' }}
              {{ node.nombre }}
            </span>
          </div>
          <ul *ngIf="node.expanded">
            <ng-container *ngTemplateOutlet="recursiveTree; context: { $implicit: node.hijos }"></ng-container>
          </ul>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</ng-template>

<!-- Modal buscador de archivos -->
<div class="custom-modal" *ngIf="showSearchModal">
  <div class="custom-modal-content-search">
    <div class="custom-modal-header">
      <h5 class="custom-modal-title" i18n>Buscar archivos</h5>
      <button type="button" class="btn-close" (click)="closeSearchModal()"></button>
    </div>
    <div class="custom-modal-body">
      <app-buscador-archivos [idExpediente]="this.id_expediente"
        (navigateToFolder)="navigateToFolderById($event)"></app-buscador-archivos>
    </div>
  </div>
</div>

<!-- Modal para renombrar archivo -->
<div class="rename-folder-modal" *ngIf="showRenameFileModal">
  <div class="rename-folder-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Renombrar archivo</h5>
    </div>
    <div class="rename-folder-modal-body">
      <form [formGroup]="renameFileForm">
        <div class="form-group">
          <label for="renameFileName" i18n>Nuevo nombre</label>
          <input type="text" id="renameFileName" formControlName="nuevoNombre" class="form-control"
            [ngClass]="{'is-invalid': renameFileForm.get('nuevoNombre')?.invalid && renameFileForm.get('nuevoNombre')?.touched}">
          <div *ngIf="renameFileForm.get('nuevoNombre')?.invalid && renameFileForm.get('nuevoNombre')?.touched"
            class="invalid-feedback">
            <span i18n>El nuevo nombre del archivo es obligatorio.</span>
          </div>
        </div>
      </form>
    </div>
    <div class="rename-folder-modal-footer">
      <button type="button" class="btn btn-primary waves-effect waves-light" (click)="confirmRenameFile()"
        [disabled]="renameFileForm.invalid" style="margin-right: 20px;">
        <span class="btn-label"><i class="fe-edit-2"></i></span><span i18n>Renombrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeRenameFileModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>

<!-- ================================================================================== -->
<!-- ======================== NUEVO MODAL PARA MOVER ARCHIVO ======================== -->
<!-- ================================================================================== -->
<div class="move-file-modal" *ngIf="showMoveFileModal">
  <div class="move-file-modal-content">
    <div class="move-file-modal-header">
      <h5 class="move-file-modal-title" i18n>Mover archivo a...</h5>
    </div>
    <div class="move-file-modal-body">
      <!-- Árbol de carpetas para seleccionar destino -->
      <div class="folder-tree">
        <ul>
          <ng-container *ngFor="let node of rootDirectory.hijos">
            <ng-container *ngIf="node.permisos?.CARPETA_ACCESO_CONTENIDO !== false">
              <li>
                <div class="folder-item" [class.selected]="node === destinationFolder">
                  <span (click)="toggleFolder(node)">
                    <i [ngClass]="{'fe-chevron-down bold': node.expanded, 'fe-chevron-right': !node.expanded}"></i>
                  </span>
                  <span (click)="selectDestinationFolder(node, $event)">
                    {{ node.expanded ? '📂' : '📁' }}
                    {{ node.nombre }}
                  </span>
                </div>
                <ul *ngIf="node.expanded">
                  <ng-container *ngTemplateOutlet="moveModalRecursiveTree; context: { $implicit: node.hijos }">
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="move-file-modal-footer">
      <button type="button" class="btn btn-primary waves-effect waves-light" (click)="confirmMoveFile()"
        [disabled]="!destinationFolder || destinationFolder.id === currentDirectory.id" style="margin-right: 20px;">
        <span class="btn-label"><i class="fe-arrow-right"></i></span>
        <span i18n>Mover aquí</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeMoveFileModal()">
        <span class="btn-label"><i class="fe-x"></i></span>
        <span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>

<!-- Template para el árbol recursivo del modal "Mover a" -->
<ng-template #moveModalRecursiveTree let-nodes>
  <ul>
    <ng-container *ngFor="let node of nodes">
      <ng-container *ngIf="node.permisos?.CARPETA_ACCESO_CONTENIDO !== false">
        <li>
          <div class="folder-item" [class.selected]="node === destinationFolder">
            <span (click)="toggleFolder(node)">
              <i [ngClass]="{'fe-chevron-down bold': node.expanded, 'fe-chevron-right': !node.expanded}"></i>
            </span>
            <span (click)="selectDestinationFolder(node, $event)">
              {{ node.expanded ? '📂' : '📁' }}
              {{ node.nombre }}
            </span>
          </div>
          <ul *ngIf="node.expanded">
            <ng-container *ngTemplateOutlet="moveModalRecursiveTree; context: { $implicit: node.hijos }">
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</ng-template>
